{
  "emailSlugLabel": "E-Mail-Slug",
  "tabs": {
    "authorizedAccounts": "Autorisierte Konten",
    "fbos": "FBOs",
    "users": "Nutzer",
    "faaMapping": "FAA-Zuordnung",
    "announcements": "Ankündigungen",
    "activity": "Aktivität",
    "movableObstacles": "Bewegliche Hindernisse",
    "towingEquipment": "Schleppausrüstung",
    "aircraft": "Flugzeug",
    "labeling": "Beschriftung",
    "convertSvgs": "SVGs konvertieren",
    "systemStatus": "Systemstatus",
    "quarantine": "Quarantäne",
    "activation": "Aktivierung"
  },
  "uberAdmin": {
    "renderJobHistory": {
      "title": "Render-Auftragsverlauf",
      "description": "Aktuelle Jobs von Render (update-aircraft, movable obstacles, towing equipment). Aktualisiert sich automatisch alle 20 Sekunden.",
      "tooltips": {
        "forceRun": "Force Run setzt die Prüfsumme zurück und führt den Job aus, auch wenn sich die Daten nicht geändert haben. Nützlich zum Testen oder um sicherzustellen, dass alle Datenbanken synchronisiert sind.",
        "refreshing": "Aktualisiere Jobliste..."
      },
      "buttons": {
        "forceRun": "Erzwingen",
        "running": "Läuft..."
      },
      "columns": {
        "jobType": "Auftragsart",
        "status": "Status",
        "created": "Erstellt",
        "duration": "Dauer",
        "dashboard": "Dashboard"
      },
      "jobTypes": {
        "updateAircraft": "Flugzeug aktualisieren",
        "updateMovableObstacles": "Bewegliche Hindernisse aktualisieren",
        "updateTowingEquipment": "Schleppausrüstung aktualisieren"
      },
      "links": {
        "view": "Zeigen"
      }
    },
    "errorBoundary": {
      "title": "Etwas ist schiefgelaufen",
      "description": "Beim Laden dieses Bereichs ist ein Fehler aufgetreten. Bitte aktualisiere die Seite."
    },
    "aircraftLastUpdated": {
      "columns": {
        "checksum": "Prüfsumme",
        "lastUpdated": "Letzte Änderung",
        "tableName": "Tabellenname"
      },
      "description": "Beschreibung",
      "notAvailable": "Nicht verfügbar",
      "title": "Flugzeug zuletzt aktualisiert"
    },
    "workerStatus": {
      "columns": {
        "lastChecked": "Zuletzt geprüft",
        "status": "Status",
        "worker": "Arbeiter"
      },
      "description": "Beschreibung",
      "notAvailable": "Nicht verfügbar",
      "title": "Mitarbeiterstatus"
    }
  },
  "components": {
    "aircraftTable": {
      "searchPlaceholder": "Flugzeug suchen...",
      "headers": {
        "make": "Neu",
        "model": "Modell",
        "length": "Länge",
        "wingspan": "Spannweite",
        "tailHeight": "Heckhöhe",
        "status": "Status"
      },
      "status": {
        "deployed": "Aktiv",
        "labeling": "Beschriftung",
        "locked": "Gesperrt"
      }
    }
  },
  "announcementsAdmin": {
    "dialogTitle": {
      "new": "Neue Ankündigung",
      "edit": "Ankündigung bearbeiten"
    },
    "labels": {
      "title": "Titel",
      "body": "Inhalt",
      "mediaType": "Medientyp",
      "youtubeEmbed": "YouTube-Einbettungscode",
      "uploadImage": "Bild hochladen",
      "changeImage": "Bild ändern",
      "actionLink": "Aktionslink (optional)",
      "linkButtonText": "Link-Button-Text (optional)",
      "expirationDate": "Ablaufdatum"
    },
    "helperText": {
      "youtubeEmbed": "Füge den iframe-Einbettungscode von YouTube ein",
      "actionLink": "Gib eine URL ein, um einen klickbaren Link zur Ankündigung hinzuzufügen",
      "linkButtonText": "Standard: Mehr erfahren"
    },
    "placeholders": {
      "actionLink": "https://example.com",
      "linkButtonText": "Mehr erfahren"
    },
    "preview": {
      "expires": "Läuft ab:"
    },
    "errors": {
      "titleRequired": "Titel ist erforderlich",
      "bodyRequired": "Inhalt ist erforderlich",
      "expirationRequired": "Ablaufdatum ist erforderlich",
      "invalidYouTube": "Bitte gib einen gültigen YouTube-Iframe-Einbettungscode ein",
      "videoUrlRequired": "Video-URL ist erforderlich, wenn Video ausgewählt ist",
      "imageRequired": "Bitte lade ein Bild hoch",
      "invalidUrl": "Bitte gib eine gültige URL ein (z. B. https://example.com)",
      "saveFailed": "Speichern der Ankündigung fehlgeschlagen. Bitte versuche es erneut."
    },
    "confirmDelete": "Möchtest du diese Ankündigung wirklich löschen?",
    "buttons": {
      "create": "Erstellen",
      "update": "Updaten",
      "uploading": "Hochladen...",
      "cancel": "Abbrechen",
      "addAnnouncement": "Ankündigung hinzufügen",
      "preview": "Vorschau",
      "edit": "Bearb.",
      "delete": "Löschen",
      "close": "Schließ"
    },
    "columns": {
      "title": "Titel",
      "body": "Inhalt",
      "media": "Medien",
      "link": "Link",
      "status": "Status",
      "expires": "Läuft ab",
      "actions": "Aktionen"
    },
    "status": {
      "active": "Aktiv",
      "expired": "Abgelaufen"
    },
    "mediaTypes": {
      "none": "Keine",
      "image": "Bild",
      "video": "Video"
    }
  },
  "quarantineTab": {
    "title": "Ausstehende Mandanten (Quarantäne)",
    "description": "Flugzeuge, die bei der FlightBridge-Synchronisierung nicht im FAA-Register oder der Flugzeugbibliothek gefunden wurden. Wähle ein Flugzeug zum Zuordnen oder nutze Entfernen & erneut versuchen für die nächste Synchronisierung.",
    "successMessage": "Keine ausstehenden Anfragen – alle FlightBridge-Flugzeuge wurden erfolgreich zugeordnet!",
    "buttons": {
      "refresh": "Neu laden",
      "removeAndRetry": "Entfernen & Wiederholen ({{count}})"
    },
    "tableHeaders": {
      "tailNumber": "Kennzeichen",
      "fbo": "FBO",
      "typeHint": "Typhinweis",
      "mapToAircraft": "Flugzeug zuordnen",
      "register": "Registrieren",
      "source": "Quelle",
      "created": "Erstellt"
    },
    "tooltips": {
      "registerExplainer": "Heckkennung in FAA-Datenbank registrieren. Deaktivieren für Angebots-/Platzhalter-Kennungen.",
      "willAddToFaa": "Wird zur FAA-Datenbank hinzugefügt",
      "quotePlaceholder": "Platzhalter – wird die FAA-Datenbank nicht beeinträchtigen",
      "placeholderWarning": "Sieht nach einem Platzhalter-Kennzeichen aus – wird nur bei Bestätigung zur FAA-Datenbank hinzugefügt"
    },
    "table": {
      "noPendingTenants": "Keine offenen Mandanten",
      "mapping": "Zuordnung...",
      "selectAircraft": "Flugzeug auswählen"
    },
    "defaults": {
      "unknownFbo": "Unbekanntes FBO",
      "unknownOperator": "Unbekannt",
      "unknownTypeHint": "Unbekannt"
    },
    "dialog": {
      "title": "Ausstehende Mieter entfernen & wiederholen",
      "description": "Entferne {{count}} ausstehende Mandant(en) aus der Quarantäne-Warteschlange.",
      "autoRetryTitle": "Auto-Wiederholung:",
      "autoRetryBody": "Der nächste geplante FlightBridge-Sync (läuft alle 5 Minuten) wird automatisch erneut versuchen, diese Tenants zu erstellen. Wenn du das FAA-Mapping korrigiert hast (das Flugzeug zur Bibliothek hinzugefügt oder die faa_to_airplx-Tabelle aktualisiert), wird der Tenant erfolgreich erstellt.",
      "retryNote": "Wenn die Zuordnung weiterhin fehlt, wird der Mandant erneut in Quarantäne gesetzt. Du kannst dann die Zuordnung korrigieren und es erneut versuchen.",
      "cancelButton": "Abbrechen",
      "confirmButton": "Entfernen & bei nächstem Sync erneut",
      "removing": "Entfernt..."
    },
    "snackbar": {
      "removed": "Entfernt: {{count}} ausstehende(r) Mandant(en)",
      "mapFailed": "Flugzeugzuordnung fehlgeschlagen"
    },
    "pendingCount": "Ausstehend",
    "selectionCount": "Auswahlanzahl"
  },
  "aircraftAdmin": {
    "title": "Flugzeugdatenbank",
    "loading": "Lade Flugzeugdaten...",
    "status": {
      "locked": "Gesperrt",
      "deployed": "Aktiv",
      "labeling": "Beschriftung"
    },
    "exportHeaders": {
      "make": "Neu",
      "model": "Modell",
      "length": "Länge",
      "wingspan": "Spannweite",
      "tailHeight": "Heckhöhe",
      "status": "Status",
      "id": "ID"
    },
    "aircraftDeployed": "Flugzeuge im Einsatz: <strong>{{count}}</strong>",
    "exportButton": "Flugzeugliste exportieren"
  },
  "aircraftPreview": {
    "selectPrompt": "Wähle ein Flugzeug zur Vorschau aus",
    "noImage": "Kein Bild verfügbar",
    "editButton": "Ändern",
    "fields": {
      "id": "ID:",
      "length": "Länge:",
      "wingspan": "Spannweite:",
      "tailHeight": "Heckhöhe:",
      "linkedTo": "Verknüpft mit:"
    }
  },
  "flightBridgeStatus": {
    "title": "FlightBridge-Integrationen",
    "description": "FlightBridge synchronisiert Flugpläne und Concierge-Reservierungen aus externen Flugbetriebssystemen. Jede FBO-Integration synchronisiert inkrementell basierend auf Webhooks und geplanten Updates.",
    "columns": {
      "fbo": "FBO",
      "companyId": "Unternehmens-ID",
      "status": "Status",
      "lastSync": "Letzt. Sync.",
      "error": "Fehler"
    },
    "never": "Nie"
  },
  "recentActivity": {
    "noActivity": "Keine aktuellen Aktivitäten",
    "columns": {
      "user": "User",
      "fbo": "FBO",
      "timestamp": "Zeitstempel"
    }
  },
  "weeklyActivityTable": {
    "title": "Wochenaktivität",
    "noData": "Keine Aktivitätsdaten für den ausgewählten Zeitraum verfügbar.",
    "exportButton": "Export TSV",
    "showTestFBOs": "Zeige Test-FBOs",
    "columns": {
      "fbo": "FBO"
    },
    "metrics": {
      "totalCustomers": "Kunden gesamt",
      "weeklyActive": "Wöchentlich aktiv",
      "monthlyActive": "Monatlich aktiv"
    },
    "footer": {
      "totalFBOs": "Gesamt-FBOs:"
    }
  },
  "superUserAdmin": {
    "loading": "Lädt...",
    "columns": {
      "userId": "Nutzer-ID",
      "name": "Name",
      "email": "E-Mail",
      "fbo": "FBO",
      "action": "Aktion",
      "permissions": "Berechtigungen"
    },
    "placeholders": {
      "none": "---",
      "searchUser": "Benutzer suchen",
      "searchFBO": "Suche nach FBO"
    },
    "buttons": {
      "edit": "Ändern",
      "close": "Schließen",
      "save": "Speichern",
      "saving": "Speichert..."
    },
    "roles": {
      "none": "Keine"
    },
    "moreChip": "+ {{count}} weitere",
    "dialog": {
      "title": "Bearbeiten"
    }
  },
  "buttonRemoveFBO": {
    "button": "FBO entfernen",
    "dialog": {
      "title": "FBO-Entfernung bestätigen",
      "message": "Möchtest du dieses FBO wirklich entfernen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "cancelButton": "Abbrechen",
      "confirmButton": "Bestätigen"
    }
  },
  "towingEquipmentAdmin": {
    "loading": "Lädt Schleppausrüstung...",
    "buttons": {
      "addEquipment": "Gerät hinzufügen",
      "exportList": "Ausrüstungsliste exportieren",
      "deploy": "Deployen"
    },
    "tooltips": {
      "deployOnlyProduction": "Deploy ist nur in der Produktionsumgebung verfügbar (app.airplx.com)"
    },
    "confirmations": {
      "deleteMessage": "Möchtest du {{name}} wirklich löschen?",
      "deployTitle": "Deploy bestätigen",
      "deployMessage": "Möchtest du die Schleppgeräte-Updates wirklich bereitstellen?",
      "deployOkButton": "Los geht's!"
    },
    "errors": {
      "deleteFailed": "Löschen der Ausrüstung fehlgeschlagen: {{error}}",
      "nameRequired": "Bitte gib einen Namen für das Equipment an.",
      "invalidDimensions": "Bitte gib gültige Werte für alle Maßfelder ein. Die Maße müssen positive Zahlen bis maximal 1000 Fuß sein.",
      "createFailed": "Ausrüstung konnte nicht erstellt werden. Bitte versuche es erneut.",
      "saveFailed": "Speichern der Ausrüstung fehlgeschlagen: {{error}}",
      "widthInvalid": "Breite muss eine positive Zahl bis 1000 Fuß sein.",
      "lengthInvalid": "Länge muss eine positive Zahl bis 1000 Fuß sein.",
      "heightInvalid": "Höhe muss eine positive Zahl bis 1000 Fuß sein."
    },
    "exportHeaders": {
      "name": "Name",
      "width": "Breite",
      "length": "Länge",
      "height": "Höhe",
      "towBarLength": "Schleppstangenlänge",
      "id": "ID"
    }
  },
  "movableObstacleAdmin": {
    "loading": "Lädt Hindernisse...",
    "buttons": {
      "addObstacle": "Hindernis +",
      "exportList": "Hindernisliste exportieren",
      "deploy": "Deployen"
    },
    "tooltips": {
      "deployOnlyProduction": "Deploy ist nur in der Produktionsumgebung verfügbar (app.airplx.com)"
    },
    "confirmations": {
      "deleteMessage": "Möchtest du {{name}} wirklich löschen?",
      "deployTitle": "Deploy bestätigen",
      "deployMessage": "Möchtest du wirklich bereitstellen?",
      "deployOkButton": "Los geht's!"
    },
    "errors": {
      "deleteFailed": "Hindernis konnte nicht gelöscht werden: {{error}}",
      "invalidDimensions": "Bitte gib gültige Werte für alle Felder an. Maße müssen positive Zahlen bis 1000 Fuß sein.",
      "createFailed": "Hindernis konnte nicht erstellt werden. Bitte versuche es erneut.",
      "saveFailed": "Speichern fehlgeschlagen: {{error}}",
      "widthInvalid": "Breite muss eine positive Zahl bis 1000 Fuß sein.",
      "lengthInvalid": "Länge muss eine positive Zahl bis 1000 Fuß sein.",
      "heightInvalid": "Höhe muss eine positive Zahl bis 1000 Fuß sein."
    },
    "exportHeaders": {
      "name": "Name",
      "width": "Breite",
      "length": "Länge",
      "height": "Höhe",
      "id": "ID"
    }
  },
  "aircraftMappingTab": {
    "coverage": "Abdeckung: {{percentage}} % ({{mappedTails}} / {{totalTails}})",
    "searchPlaceholder": "Suche nach FAA-Hersteller oder Modell",
    "filters": {
      "manufacturer": "Hersteller",
      "country": "Land",
      "allCountries": "Alle",
      "unmatched": "Nicht zugeord.",
      "withSuggestions": "Mit Vorschlägen"
    },
    "tableHeaders": {
      "frequency": "Frequenz",
      "faaManufacturer": "FAA-Hersteller",
      "faaModel": "FAA-Modell",
      "airplxAircraft": "AirPlx-Flugzeuge"
    },
    "tooltips": {
      "frequencyAllCountries": "Gesamtzahl der registrierten Kennzeichen für diesen Flugzeugtyp",
      "frequencyWithCountry": "Format: Länderanzahl (Gesamtanzahl) – Zeigt {{country}}-Registrierungen mit weltweiter Gesamtzahl in Klammern. Sortiert nach {{country}}-Anzahl.",
      "blacklist": "Diese FAA-Kategorie blockieren (Drohnen, Ballons usw.)"
    },
    "snackbar": {
      "blacklisted": "Blockiert: {{manufacturer}} {{model}}",
      "blacklistFailed": "Sperren fehlgeschlagen. Bitte erneut versuchen.",
      "bulkApplySuccess": "{{appliedCount}} Zuordnungen angewendet ({{skippedCount}} übersprungen)",
      "bulkApplyFailed": "Massenanwendung fehlgeschlagen: {{message}}",
      "reApplySuccess": "Muster {{query}} erneut angewendet: {{appliedCount}} Zuordnungen ({{skippedCount}} übersprungen)",
      "reApplyFailed": "Erneut anwenden fehlgeschlagen: {{message}}",
      "patternDeleted": "Muster gelöscht",
      "patternDeleteFailed": "Löschen fehlgeschlagen: {{message}}"
    }
  },
  "activation": {
    "overview": {
      "title": "Benutzeraktivierung – Übersicht",
      "description": "Aktivierungsfortschritt der Benutzer über FBOs hinweg verwalten",
      "fboFilter": "FBO",
      "allFbos": "Alle FBOs",
      "searchPlaceholder": "Nach Name oder E-Mail suchen",
      "filterLabel": "Status",
      "noData": "Keine Benutzer gefunden",
      "viewDetails": "Details anzeigen",
      "columns": {
        "user": "Benutzer",
        "fboName": "FBO",
        "state": "Status",
        "autostackRuns": "AutoStack-Läufe",
        "checklist": "Checkliste",
        "timeline": "Zeitachse",
        "mode": "Checkliste anzeigen",
        "actions": "Aktionen"
      },
      "states": {
        "pre": "Vor Aktivierung",
        "shallow": "Oberflächlich",
        "deep": "Tief"
      },
      "filters": {
        "all": "Alle Benutzer",
        "active": "Nur aktive",
        "stalled": "Stockend",
        "deep": "Tief aktiviert"
      }
    },
    "detail": {
      "title": "Aktivierungsdetails",
      "userInfo": "Benutzerinformationen",
      "checklistProgress": "Checklisten-Fortschritt",
      "adminControls": "Admin-Steuerungen",
      "auditLog": "Änderungsverlauf",
      "notes": "Interne Notizen",
      "reason": "Grund für Änderung",
      "reasonHelp": "Optionale Notiz für Audit-Log",
      "notCompleted": "Nicht abgeschlossen",
      "markComplete": "Als abgeschlossen markieren",
      "uncheckStep": "Schritt zurücksetzen",
      "controls": {
        "startDate": {
          "label": "Aktivierung gestartet",
          "help": "Für Testzeitraum-Korrekturen anpassen",
          "update": "Aktualisieren"
        },
        "windowDays": {
          "label": "Aktivierungszeitraum (Tage)",
          "help": "Aktivierungszeitraum verlängern oder verkürzen"
        },
        "threshold": {
          "label": "Schwellenwert tiefe Aktivierung",
          "help": "Wie viele AutoStack-Läufe = tiefe Aktivierung"
        },
        "variant": {
          "label": "Checklisten-Stil",
          "help": "Welche UI-Variante angezeigt wird",
          "options": {
            "sidebar": "Seitenleiste",
            "floating": "Schwebende Karte",
            "banner": "Oberes Banner"
          }
        },
        "forceDeep": {
          "label": "Tiefe Aktivierung erzwingen",
          "help": "Manuell als tief aktiviert markieren (selten)"
        }
      }
    }
  }
}
